import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const RealTimeSchedulingSchemesModule = () => (
  <QPhototModuleSubtopic
    title="Real Time Scheduling Schemes - EDF, RMS & Hybrid Techniques"
    videos={[
      "https://www.youtube.com/embed/oU4RwHkmnaM",
      "https://www.youtube.com/embed/xgW8VhEOpFg",
      "https://www.youtube.com/embed/ejPXTOcMRPA",
      "https://www.youtube.com/embed/iBBvN1XN2DI",
      "https://www.youtube.com/embed/J35OsBsvHDU"
    ]}
    takeaways={[]}
    questions={[
      {
        text:
          "Compare and contrast RMS with EDF. Schedule the given task table using RMS.",
        image:"/es_3.png"
      },
      {
        text:
          "Explore and elaborate on the requirements of a real-time hybrid scheduler. Determine the execution of tasks with a detailed task timeline graph for the given tasks.",
        image:"/es_4.png"
      },
      {
        text:
          "Using the given dataset, show that RMS creates a feasible schedule. If the current execution times do not allow for a feasible schedule, adjust the execution times, create new values, and try RMS scheduling again. Draw a task timeline graph for at least three cycles.",
        image:"/es_5.png"
      },
      {
        text:
          "Evaluate how the following parameters affect the schedulability of real-time tasks: Arrival Time, Current Time / Scheduling point, Execution Time, Rate or Period, Deadline. Suggest an optimal scheduling scheme using any three relevant parameters and apply it for the given dataset. Illustrate the task timeline graph for at least three cycles.",

        image:"/es_6.png"
      },
      {
        text:
          "A database system allows multiple clients to read data simultaneously, but only one client can write data at a time. Using POSIX semaphores, implement a solution to: (i) Allow concurrent reads, (ii) Ensure exclusive access for writes, (iii) Prevent starvation of readers or writers. Explain the role of each semaphore and provide implementation with suitable code."
      },
      {
        text:
          "Compare and contrast RMS and EDF. Schedule the given task table using both RMS and EDF.",
        image:"/es_7.png"
      },
      {
        text:
          "Evaluate how the following parameters affect the schedulability of real-time tasks: Arrival Time, Current Time / Scheduling point, Execution Time, Rate or Period, Deadline. Suggest an optimal scheduling scheme using any three parameters mentioned above and apply it for the given dataset.",
        image:"/es_8.png",
        
      },
      { text:
          "Evaluate how the following parameters affect the schedulability of real-time tasks: Arrival Time, Current Time / Scheduling point, Execution Time, Rate or Period, Deadline. Suggest an optimal scheduling scheme using any three parameters mentioned above and apply it for the given dataset.",
        image:"/es_9.png"
      },
      {
        text:
          "Compute the CPU utilization and check whether the given tasks are schedulable in an RTOS. Apply RMS and EDF algorithms on the given data. Illustrate the task timeline graph for two cycles.",
        image:"/es_10.png"
      },
      {
        text:
          "A car manufacturing industry has various tasks to be carried out. Task 1 takes 2 seconds and is repeated every 4 seconds, Task 2 takes 3 seconds and is carried out every 8 seconds, and Task 3 takes 4 seconds and is repeated every 24 seconds. Assume all the tasks arrive at time 0. Schedule the tasks based on any two scheduling models and analyse the CPU utilization and the constraints for each model with a time graph."
      },
      {
        text:
          "A smart city project has huge data which is collected and used for prediction and analysis. There are 3 processes which happen simultaneously. Build the 3 processes using POSIX and also incorporate scheduling."
      }
    ]}
    exampleVideos={[]}
  />
);

export default RealTimeSchedulingSchemesModule;
